/* tslint:disable */
/* eslint-disable */
export enum ProjectStates {
  NotLaunched = 'NotLaunched',
  Launched = 'Launched',
  Contracted = 'Contracted'
}
